"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = exports.BiggestStorage = exports.MODULE_NAME_STORE = void 0;
exports.MODULE_NAME_STORE = 'store';
__exportStar(require("./constants"), exports);
__exportStar(require("./cookies"), exports);
__exportStar(require("./cookieStorage"), exports);
__exportStar(require("./indexedDB/indexedDB"), exports);
__exportStar(require("./memoryStorage"), exports);
__exportStar(require("./messages"), exports);
__exportStar(require("./options"), exports);
__exportStar(require("./storeAsync"), exports);
__exportStar(require("./synchronized"), exports);
var biggestStorage_1 = require("../store/biggestStorage");
Object.defineProperty(exports, "BiggestStorage", { enumerable: true, get: function () { return biggestStorage_1.BiggestStorage; } });
var store_1 = require("../store/store");
Object.defineProperty(exports, "Store", { enumerable: true, get: function () { return store_1.Store; } });
//# sourceMappingURL=index.js.map